export function AddSequences(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists/${ID}/sequences`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists/${ID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists`;
}

export function RemoveSequences(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists/${ID}/sequences`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists/${ID}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists/${ID}`;
}

export function UpdateSequenceOrder(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-playlists/${ID}/sequences`;
}

